import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { captureUtmParamsFromUrl } from '../utils/utmTracking';

/**
 * Captures UTM params from the current URL into sessionStorage on every
 * URL change. Mount once inside <Router>.
 */
export function useCaptureUtmParams(): void {
  const [searchParams] = useSearchParams();
  useEffect(() => {
    captureUtmParamsFromUrl(searchParams);
  }, [searchParams]);
}
